module.exports = __webpack_public_path__ + "assets/img/pdf.8f7674eb.png";